// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchField-module--input--jtbVj","higher":"SearchField-module--higher--3jv85"};